﻿$.fn.dxCtrlSondageConsolide = function custom_dxCtrlSondageConsolide(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondageconsolide dx-ctrl");
        this.createInstance(new cdxCtrlSondageConsolide(this, option));
    }
    return this;
}

window.cdxCtrlSondageConsolide = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var jauge = null
    var sondageConsolide = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()

        mGetSondageConsolide(option.bddCtrl, option.dataSondage, option.dataSondageReponse, function (sondConsolide) {
            sondageConsolide = sondConsolide
            if (option.dateDebut) {
                sondageConsolide.getDateRef({
                    date_debut: option.dateDebut,
                    date_fin: option.dateFin
                })
            }
            if (typeof option.justeFinalise != 'undefinded') {
                sondageConsolide.getSeulementFinaliseValue(option.justeFinalise)
            }
            mRempli()
            if (option.onContentReady) option.onContentReady(sondageConsolide)
        })
    }

    var $DivResultSondage = null
    var $DivTitle = null
    function mRempli() {
        container.empty();
        if (!option.forPrint) {
            container.css("padding", "0 5%")
            container.css("height", "100%")
        }
        container.css("text-align", "center")

        var $DivTot = $("<div style='display:inline-block;width:100%;max-width:800px;'/>").appendTo(container)

        //title
        $DivTitle = $("<div/>").appendTo($DivTot)

        if (option.forPrint) {
            $("<div style='font-size:140%;font-weight:bold;'/>").appendTo($DivTitle).text(option.dataSondage.nom)
        }

        if (option.dataSondageReponse) {
            //on sur une réponse précise
            if (option.dataSondageReponse.id_table_destinataire) {
                option.bddCtrl.mAjaxCall({
                    command: "getlstdatavirtualgrid",
                    data: [{ id_table: option.dataSondageReponse.id_table_destinataire, id: option.dataSondageReponse.id_destinataire }]
                }, function (data) {
                    var dataTemplate = data.lstdatatemplate[0]
                    var clDataSaisie = new cDataSaisie({ bddCtrl: option.bddCtrl })
                    clDataSaisie.mInitWithDataTemplate(dataTemplate)
                    var $Table = $("<table style='width:100%;'/>").appendTo($DivTitle)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlDataSaisieVisu({
                        bddCtrl: option.bddCtrl,
                        dataSaisie: clDataSaisie.data
                    })
                    if (option.bddCtrl.objCptCli.objetMetier.hasBdd()) {
                        var $Td = $("<td style='width:1px;vertical-align:top;'/>").appendTo($Tr)
                        $("<div/>").appendTo($Td).dxCtrlButton({
                            icon: "fas fa-arrow-up-right-from-square",
                            hint: "Ouvrir la fiche du contact",
                            onClick: function (e) {
                                e.event.stopPropagation()
                                option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataTemplate.id_table_key).nom, dataTemplate.id_key).mShowPopup()
                            }
                        })
                    }
                })
            } else {
                $("<div style='padding:15px;'/>").text("(Aucun contact lié à cette réponse)").appendTo($DivTitle)
            }
            $("<div style='padding:15px;'/>").text("Réponses du " + option.dataSondageReponse.dcr.toDDMMMMAAAA()).appendTo($DivTitle)
        } else {
            $("<div style='padding:15px 15px 0 15px;'/>").text("Réponses du " + sondageConsolide.minDate.toDDMMMMAAAA() + " au " + sondageConsolide.maxDate.toDDMMMMAAAA() + "").appendTo($DivTitle)
            if (sondageConsolide.nbRepondantTotal() == 0) {
                $("<div style='padding:15px;'/>").text("(Aucun répondant)").appendTo($DivTitle)
            } else {
                if (!option.forPrint) {
                    var dxRangeSelect = $("<div style='padding:0 15px;'/>").appendTo($DivTitle).dxRangeSelector({
                        margin: {
                            top: 10,
                            bottom: 0
                        },
                        size: {
                            width: "100%",
                        },
                        scale: {
                            startValue: sondageConsolide.minDate,
                            endValue: sondageConsolide.maxDate,
                            tickInterval: 'month',
                            minorTickInterval: 'month',
                            minorTick: {
                                visible: false,
                            },
                        },
                        sliderMarker: {
                            format: 'monthAndYear',
                        },
                        value: [
                            sondageConsolide.getDateRef().dateDebut,
                            sondageConsolide.getDateRef().dateFin
                        ],
                        onValueChanged: function (e) {
                            sondageConsolide.getDateRef({
                                date_debut: e.value[0],
                                date_fin: e.value[1]
                            })
                            mRempliResultSondage()
                        }
                    }).dxRangeSelector("instance");
                }
            }
        }

        $DivResultSondage = $("<div/>").appendTo($DivTot)
        mRempliResultSondage()
    }

    function mRempliResultSondage() {
        $DivResultSondage.empty()

        if (!sondageConsolide.isUnitaire) {
            var ds = ["" + sondageConsolide.nbRepondantTotal() + " répondants", sondageConsolide.nbRepondantFinalise() + " complet"]
            $("<div style='margin:0 10px 10px 10px;'/>").appendTo($DivResultSondage).dxCtrlRadioButton({
                dataSource: ds,
                value: (sondageConsolide.getSeulementFinaliseValue() ? ds[1] : ds[0]),
                onValueChanged: function (e) {
                    sondageConsolide.getSeulementFinaliseValue(ds.indexOf(e.value) == 1)
                    mRempliResultSondage()
                }
            }).dxCtrlRadioButton("instance")
        }

        var $Table = $("<table style='width:100%;margin:10px;table-layout:fixed;'/>").appendTo($DivResultSondage)
        var $Tr = $("<tr/>").appendTo($Table)

        var $Td = $("<td style='width:20%;padding:0 10px;'/>").appendTo($Tr)
        $Td.attr("title", sondageConsolide.lstPage.length + " pages de questions")
        var $Div = $("<div style='border:" + theme.border + ";border-radius:10px;padding:15px;height:86px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo($Td)
        $("<div style='opacity:0.6;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).text("Pages")
        $("<div style='font-size:200%;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).text(sondageConsolide.lstPage.length)

        var $Td = $("<td style='width:20%;padding:0 10px;'/>").appendTo($Tr)
        $Td.attr("title", sondageConsolide.nbQuestion + " questions")
        var $Div = $("<div style='border:" + theme.border + ";border-radius:10px;padding:15px;height:86px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo($Td)
        $("<div style='opacity:0.6;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Div).text("Questions")
        $("<div style='font-size:200%;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).text(sondageConsolide.nbQuestion)

        var $Td = $("<td style='width:20%;padding:0 10px;'/>").appendTo($Tr)
        $Td.attr("title", sondageConsolide.nbRepondantTotal() + " répondants")
        var $Div = $("<div style='border:" + theme.border + ";border-radius:10px;padding:15px;height:86px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo($Td)
        $("<div style='opacity:0.6;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Div).text("Répondants")
        $("<div style='font-size:200%;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).text(sondageConsolide.nbRepondantTotal())

        var $Td = $("<td style='width:20%;padding:0 10px;'/>").appendTo($Tr)
        $Td.attr("title", sondageConsolide.nbRepondantFinalise() + " répondants sont allé au bout du sondage")
        var $Div = $("<div style='border:" + theme.border + ";border-radius:10px;padding:15px;height:86px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo($Td)
        $("<div style='opacity:0.6;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Div).text("Complet")
        $("<div style='font-size:200%;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).text(sondageConsolide.nbRepondantFinalise())

        var result = sondageConsolide.mGetTauxSatisfaction()
        var txSatisfaction = ""
        if (result && result.tx > 0) {
            txSatisfaction = result.tx.formatDisplay(0) + "%"
        } else { txSatisfaction = "---" }
        var $Td = $("<td style='width:25%;padding:0 10px;'/>").appendTo($Tr)
        $Td.attr("title", "Taux de satisfaction:<br/><b style='font-size:200%;'>" + txSatisfaction + "</b>")
        var $Div = $("<div style='border:" + theme.border + ";border-radius:10px;padding:15px;height:86px;background-color:" + theme.backgroundColorTitle + ";'/>").appendTo($Td)
        $("<div style='opacity:0.6;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Div).text("Satisfaction")
        $("<div style='font-size:200%;font-weight:bold;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;'/>").appendTo($Div).html(txSatisfaction)


        //content
        var content = null
        if (option.disableScroll) {
            content = $("<div/>").appendTo($DivResultSondage)
        } else {
            var dxScrollDetail = $("<div/>").appendTo($DivResultSondage).dxScrollView({}).dxScrollView("instance")
            content = dxScrollDetail.content()
            content.css("padding-right", "3px")
            resizeObserver.mAdd([container, $DivTitle], function () {
                dxScrollDetail.element().css("height", "calc(100% - " + ($DivTitle.innerHeight() + 5) + "px)")
            })()
        }

        $("<div/>").appendTo(content).dxAccordion({
            dataSource: sondageConsolide.lstPage,
            collapsible: true,
            multiple: true,
            selectedItems: (option.forPrint ? sondageConsolide.lstPage : [sondageConsolide.lstPage[0]]),
            itemTitleTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("height", "auto")
                itemElement.css("text-align", "left")
                var $Table = $("<table style='width:calc(100% - 25px);table-layout:fixed;margin:10px;'>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:40px;vertical-align:middle;' class='dx-theme-accent-as-text-color'/>").appendTo($Tr)
                $Td.text((itemIndex + 1) + "/" + sondageConsolide.lstPage.length)

                var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
                $("<div style='font-weight:bold;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-size:130%;'/>").text(itemData.titre).appendTo($Td)
                var nbQuest = itemData.lst_question.filter(function (quest) { return quest.type != "text" }).length
                $("<div style='opacity:0.7;'/>").text(nbQuest + " question" + (nbQuest > 1 ? "s" : "")).appendTo($Td)

                var $Td = $("<td style='width:80px;vertical-align:middle;text-align:center;opacity:0.7;'/>").appendTo($Tr)
                $("<div style='font-family:barlow condensed;' class='dx-theme-accent-as-text-color'>Satisfaction</div>").appendTo($Td)
                var result = sondageConsolide.mGetTauxSatisfaction(null, itemData)
                var txSatisfaction = ""
                if (result.tx > 0) {
                    txSatisfaction = result.tx.formatDisplay(0) + "%"
                } else { txSatisfaction = "---" }
                $("<div style='font-weight:bold;font-size:160%;'/>").appendTo($Td).html(txSatisfaction)
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("padding-top", "0")
                itemElement.css("padding-bottom", "0")
                itemElement.css("text-align", "left")
                if (itemData.lst_question.length == 0) {
                    var $Div = $("<div style='padding:30px;text-align:center;opacity:0.5;'/>").appendTo(itemElement).text("(Aucune question)")
                } else {
                    itemData.lst_question.filter(function (o) { return o.type != "text" }).forEach(function (question, idx) {
                        if (idx > 0 && idx < itemData.lst_question.length - 1) $("<hr style='opacity:0.6;'/>").appendTo(itemElement)
                        var $Div = $("<div style='padding:10px 10%;'/>").appendTo(itemElement)
                        //var $Div = $("<div style='white-space:nowrap;overflow:hidden;'/>").appendTo(itemElement).text($("<div>").html(question.text_intro || "").text())
                        //$Div.attr("title", question.text_intro)
                        switch (question.type) {
                            case "ouinon":
                                mRempliOuiNon($Div, question)
                                break;
                            case "chk":
                                mRempliChk($Div, question)
                                break;
                            case "radio":
                                mRempliRadio($Div, question)
                                break;
                            case "textbox":
                                mRempliTextbox($Div, question)
                                break;
                            case "text":
                                break;
                        }
                    })
                }
            }
        })

        jauge.mHide()
    }

    function mRempliOuiNon(itemElement, question) {
        var dataSource = sondageConsolide.mGetDataQuestion(question)
        $("<div/>").appendTo(itemElement).dxCtrlSondageQuestionOuiNonConsolide({
            bddCtrl: option.bddCtrl,
            dataSource: dataSource.dataSource,
            question: question,
            nb_repondant: dataSource.nb_repondant,
            sondageConsolide: sondageConsolide
        })
    }

    function mRempliChk(itemElement, question) {
        var dataSource = sondageConsolide.mGetDataQuestion(question)
        $("<div/>").appendTo(itemElement).dxCtrlSondageQuestionChkRadioConsolide({
            bddCtrl: option.bddCtrl,
            dataSource: dataSource.dataSource,
            question: question,
            nb_repondant: dataSource.nb_repondant,
            sondageConsolide: sondageConsolide
        })
    }

    function mRempliRadio(itemElement, question) {
        var dataSource = sondageConsolide.mGetDataQuestion(question)
        $("<div/>").appendTo(itemElement).dxCtrlSondageQuestionChkRadioConsolide({
            bddCtrl: option.bddCtrl,
            dataSource: dataSource.dataSource,
            question: question,
            nb_repondant: dataSource.nb_repondant,
            sondageConsolide: sondageConsolide
        })
    }
    function mRempliTextbox(itemElement, question) {
        var dataSource = sondageConsolide.mGetDataQuestion(question)
        $("<div/>").appendTo(itemElement).dxCtrlSondageQuestionTextBoxConsolide({
            bddCtrl: option.bddCtrl,
            resume: dataSource.resume,
            question: question,
            nb_repondant: dataSource.nb_repondant,
            sondageConsolide: sondageConsolide
        })
    }

    this.element = function () { return container; }
    this.component = function () { return Me; }

    mConstruit();
}